import {
  Button,
  ButtonProps,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps as MuiDialogProps,
  DialogTitle,
  IconButton,
  Slide,
  Typography,
} from "@material-ui/core";
import MuiDialog from "@material-ui/core/Dialog";
import { makeStyles, Theme, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Close } from "@material-ui/icons";
import { theme } from "config/theme";
import { COLORS, CSS_COLOR_VARS } from "constants/colors";
import useText from "constants/text";
import React from "react";
import "styled-components/macro";
import { SlideTransition } from "ui/Transition";

export interface StylesPropsNT {
  left?: string;
  height?: string;
  top?: string;
  width?: string;
  withTitle?: string;
  sizeContent?: string;
}
export const useStyles = makeStyles<Theme, StylesPropsNT>({
  paperWidthMd: {
    width: 740,
  },
  colorAddress: { color: "#757a93", fontWeight:"bold", position:"relative", right:"65px"},
  cancelButton: {
    backgroundColor: "#cfecf8",
    borderColor: COLORS.primary,
    color: COLORS.primary,
    width: "120px",
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      left: ({ left }) => left || "17rem",
      width: ({ width }) => width || "123vw",
    },
  },
  confirmButton: {
    [theme.breakpoints.down("xs")]: {
      position: "relative",
      right: "40px",
      width: ({ width }) => width || "123vw",
    },
  },
  paperWidthLg: {
    width: 940,
  },
  dialogSpacingContent: {
    padding: "40px",
    [theme.breakpoints.down("xs")]: { padding: "62px 10px 25px 10px", overflowX: "hidden" },
  },
  paperDialogRoot: {
    boxShadow: "0px 15px 20px 3px rgba(0, 0, 0, 0.1)",
    width: ({ sizeContent }) => sizeContent || "auto",
    height: ({ height }) => height || "500",
    [theme.breakpoints.down("xs")]: { width: "93%", height: "70vh", overflowY: "unset" },
  },
  modalRoot: {
    position: "relative",
    boxShadow: "0px 15px 20px 3px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("xs")]: {
      width: "93%",
      height: ({ height }) => height || "auto",
      overflowY: "unset",
      top: ({ top }) => top || "",
      zIndex: 1,
    },
  },
  dialogActions: {
    marginTop: "30px",
    [theme.breakpoints.down("xs")]: {
      padding: "12px 146px 12px 0px",
    },
  },
  actionsDialog: { [theme.breakpoints.down("xs")]: { background: "red" } },
  dialogActionsContainer: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },
  dialogActionsRoot: {
    marginLeft: "auto",
    padding: 0,
  },
  dialogActionsConfirmClose: {
    position: "absolute",
    bottom: 0,
    justifyContent: "flex-end",
    backgroundColor: CSS_COLOR_VARS.backgroundPrimary,
    pointerEvents: "auto",
    width: "100%",
    padding: "14px 28px",
    borderRadius: "4px",
    zIndex: theme.zIndex.modal + 1,
    boxSizing: "border-box",
    textTransform: "none",
  },
  countText: {
    fontWeight: 500,
    color: "orange",
    marginLeft: "30px",
  },
  dialogTitle: {
    fontWeight: "bold",
    fontSize: 18,
    height: 22,
    fontFamily: "Montserrat",
    color: COLORS.primary,
    textAlign: "left",
    width:  ({ withTitle }) => withTitle || "100%",
    [theme.breakpoints.down("xs")]: {
      fontWeight: "bold",
      fontSize: 16,
      height: 22,
      fontFamily: "Montserrat",
      color: COLORS.primary,
      textAlign: "left",
      width: "100%",
    },
  },
  clearContent: {
    display: "flex",
    width: "100%",
    color: COLORS.primary,
    textTransform: "capitalize",
  },
});

export interface ExtendedButtonProps extends ButtonProps {
  "data-testid"?: string;
}

export interface DialogProps extends MuiDialogProps {
  title?: string | any;
  subtitle?: string;
  withTitle?: string;
  sizeContent?: string;
  customDialogTitle?: React.ReactNode;
  count?: string;
  confirmButtonTitle?: string | React.ReactNode;
  cancelButtonTitle?: string;
  handleClose?(event?: any, reason?: string): void;
  handleConfirm?(): void;
  disableConfirmButton?: boolean;
  PrimaryButtonProps?: ExtendedButtonProps;
  SecondaryButtonProps?: ExtendedButtonProps;
  isFormDirty?: boolean;
  hasStickyBars?: boolean;
  height?: string;
  removeBottomBar?: boolean;
  dialogActionButtonCustomized?: boolean;
  hasClearButton?: boolean;
  handlerClear?(): void;
  hideDialogHeader?: boolean;
  confirmButtonStyle?: React.CSSProperties;
  closeButtonStyle?: React.CSSProperties;
  dialogActionStyle?: React.CSSProperties;
  customStyle?: string;
  actionTop?: string;
  actionWidth?: string;
  actionLeft?: string;
  showCloseIcon?: boolean;
  titleClassNames?: string;
  disableTypographyTitle?: boolean;
  address?: string;
}

export default function Dialog({
  title,
  address,
  sizeContent,
  subtitle,
  count,
  confirmButtonStyle = {},
  closeButtonStyle = {},
  dialogActionStyle = {},
  confirmButtonTitle = "Confirm",
  cancelButtonTitle = "Cancel",
  disableConfirmButton = false,
  handleConfirm,
  handleClose,
  PrimaryButtonProps = {},
  SecondaryButtonProps = {},
  isFormDirty = false,
  children,
  hasStickyBars = false,
  maxWidth = "sm",
  height,
  customDialogTitle,
  removeBottomBar = false,
  dialogActionButtonCustomized = false,
  hasClearButton = false,
  hideDialogHeader = false,
  customStyle,
  showCloseIcon = true,
  handlerClear,
  titleClassNames,
  disableTypographyTitle = true,
  actionLeft = "11.6rem",
  actionTop = "30px",
  actionWidth = "141px",
  withTitle,
  ...props
}: DialogProps) {
  const { text } = useText();
  const classes = useStyles({ left: actionLeft, top: actionTop, width: actionWidth , withTitle, sizeContent});
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

  const [showFooterActions, setShowFooterActions] = React.useState(false);
  const [, setTopSticky] = React.useState(false);
  const [, setBottomSticky] = React.useState(false);
  const dialogRef = React.useRef(null);

  const handleScroll = React.useCallback(() => {
    let throttleTimeout: any = null;

    function goesSticky() {
      const scrollEl = dialogRef?.current;
      const scrollTop = scrollEl?.scrollTop;

      const doesTopStick = window?.scrollY === scrollTop;
      const doesBottomStick = scrollTop + scrollEl?.clientHeight === scrollEl?.scrollHeight;

      setTopSticky(!doesTopStick);
      setBottomSticky(!doesBottomStick);

      throttleTimeout = null;
    }

    if (throttleTimeout === null) {
      throttleTimeout = setTimeout(goesSticky, 200);
    } else {
      goesSticky();
    }
  }, [setTopSticky]);

  function handleCloseDialog(event: any, reason?: string) {
    if (removeBottomBar) {
      handleButtonCloseDialog(event, reason);
    } else {
      handleButtonCloseDialog(event, reason);
    }
  }
  function handleButtonCloseDialog(event: any, reason?: string) {
    if (!isFormDirty) {
      handleClose && handleClose(event, reason);
      setShowFooterActions(false);
    } else {
      setShowFooterActions(true);
    }
  }

  React.useEffect(() => {
    if (hasStickyBars) {
      window.addEventListener("scroll", handleScroll, true);

      return () => {
        window.removeEventListener("scroll", () => handleScroll, true);
      };
    }
  }, [handleScroll, hasStickyBars]);

  return (
    <MuiDialog
      fullWidth
      maxWidth={maxWidth}
      TransitionComponent={props.TransitionComponent || SlideTransition}
      fullScreen={fullScreen}
      onClose={(event, reason) => handleCloseDialog(event, reason)}
      scroll="paper"
      aria-labelledby={title?.toLowerCase().split(" ").join("-")}
      {...props}
      css={`
        > div > .MuiPaper-root {
          ${height && `height: ${fullScreen ? height : height}`};
          ${hideDialogHeader && `overflow-y: inherit !important`};
          ${customStyle ?? customStyle}
        }
      `}
      className={isFormDirty && "dirty"}
      classes={{
        paperWidthMd: classes.paperWidthMd,
        paperWidthLg: classes.paperWidthLg,
        paper: classes.paperDialogRoot,
        paperFullScreen: classes.modalRoot,
      }}
    >
      {!hideDialogHeader && (
        <DialogTitle disableTypography={disableTypographyTitle}>
          {customDialogTitle || (
            <><Typography variant="h3" className={titleClassNames || classes.dialogTitle}>
              {title}
            </Typography><span className={classes.colorAddress}> {address} </span></>
          )}
          {count && (
            <Typography variant="h5" className={classes.countText}>
              {count} {text.all.scanned}
            </Typography>
          )}
          {showCloseIcon && (
            <IconButton
              onClick={(event) => handleCloseDialog(event, "icon")}
              css={`
                margin-left: auto;
                padding: 8px;
              `}
            >
              <Close fontSize="small" color="action" />
            </IconButton>
          )}
        </DialogTitle>
      )}

      <DialogContent ref={dialogRef} className={classes.dialogSpacingContent}>
        {subtitle && <DialogContentText>{subtitle}</DialogContentText>}
        {children}
      </DialogContent>

      {!dialogActionButtonCustomized && !removeBottomBar && (
        <>
          {((handleClose && cancelButtonTitle?.length) || handleConfirm) && (
            <DialogActions className={classes.dialogActions} style={dialogActionStyle}>
              {hasClearButton && (
                <div className={classes.clearContent}>
                  <Button variant="outlined" onClick={handlerClear} style={closeButtonStyle}>
                    {text.all.clear_button}
                  </Button>
                </div>
              )}
              {handleClose && (
                <Button
                  variant="outlined"
                  style={closeButtonStyle}
                  className={classes.cancelButton}
                  onClick={(event) => handleCloseDialog(event, "button")}
                  {...SecondaryButtonProps}
                >
                  {cancelButtonTitle}
                </Button>
              )}

              {handleConfirm && (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.confirmButton}
                  style={{
                    opacity: disableConfirmButton ? 0.5 : 1,
                    backgroundColor: COLORS.primary,
                    color: COLORS.white,
                  }}
                  disabled={disableConfirmButton}
                  onClick={handleConfirm}
                  {...PrimaryButtonProps}
                >
                  {confirmButtonTitle}
                </Button>
              )}
            </DialogActions>
          )}
        </>
      )}
      <Slide direction="up" in={showFooterActions} mountOnEnter unmountOnExit>
        <div className={`${classes.dialogActionsContainer} ${classes.dialogActionsConfirmClose}`}>
          <div
            css={`
              max-width: 45%;
            `}
          >
            <span
              css={`
                color: #ed7172;
              `}
            >
              {text.all.discard_dialog_msg}
            </span>
            <b
              css={`
                color: #707070;
              `}
            >
              {text.all.discard_dialog_question}
            </b>
          </div>
          <DialogActions className={classes.dialogActionsRoot}>
            <Button
              variant="outlined"
              onClick={() => setShowFooterActions(false)}
              style={{
                textTransform: "none",
                color: "#ed7172",
              }}
            >
              {text.all.stay_button_dialog}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={(event) => {
                handleClose && handleClose(event);
                setShowFooterActions(false);
              }}
              {...SecondaryButtonProps}
              style={{
                textTransform: "none",
                backgroundColor: "#ed7172",
              }}
            >
              {text.all.discard_button_dialog}
            </Button>
          </DialogActions>
        </div>
      </Slide>
    </MuiDialog>
  );
}
